import { IImageSettings } from '~/domain/IImageSettings';
import {
  CENTERPANO_IMAGE_QUALITY,
  CENTERPANO_PREVIEW_IMAGE_QUALITY,
  EXTERIOR360_IMAGE_QUALITY,
  EXTERIOR360_PREVIEW_IMAGE_QUALITY,
  FEATURE_SHOT_IMAGE_QUALITY,
  FEATURE_SHOT_LIST_IMAGE_QUALITY,
  FEATURE_SHOT_PREVIEW_IMAGE_QUALITY,
  INTERIOR360_IMAGE_QUALITY,
  INTERIOR360_PREVIEW_IMAGE_QUALITY,
} from '~/env';

const build = (quality: string, defaults: string, fixed = ''): IImageSettings => {
  const array = (quality || defaults).split('&');
  const width = parseInt(array.find(x => x.match(/^w=/))?.split('=')[1] || '0', 10);
  const height = parseInt(array.find(x => x.match(/^h=/))?.split('=')[1] || '0', 10);
  return {
    width,
    height,
    quality: (quality || defaults) + fixed,
    aspectRatio: width / height,
  };
};

//export const FEATURE_SHOT_LIST_IMAGE_SETTINGS = build(FEATURE_SHOT_LIST_IMAGE_QUALITY, 'w=480&h=270&taa=3&ssaa=2&fxaa');
export const FEATURE_SHOT_LIST_IMAGE_SETTINGS = build(FEATURE_SHOT_LIST_IMAGE_QUALITY, 'w=4096&h=2731&taa=3&ssaa=2&fxaa');
export const FEATURE_SHOT_IMAGE_SETTINGS = build(FEATURE_SHOT_IMAGE_QUALITY, 'w=4096&h=2731&taa=3&ssaa=2&fxaa');
export const DEALER_SHOT_LIST_IMAGE_SETTINGS = build(FEATURE_SHOT_LIST_IMAGE_QUALITY, 'w=4096&h=3072&taa=3&ssaa=2&fxaa');
export const DEALER_SHOT_IMAGE_SETTINGS = build(FEATURE_SHOT_IMAGE_QUALITY, 'w=4096&h=3072&taa=3&ssaa=2&fxaa');
//export const EXTERIOR360_IMAGE_SETTINGS = build(EXTERIOR360_IMAGE_QUALITY, 'w=1920&h=1012&taa=3&ssaa=2&fxaa');
export const EXTERIORSTUDIO360_IMAGE_SETTINGS = build(EXTERIOR360_IMAGE_QUALITY, 'w=1920&h=1012&taa=3&ssaa=2&fxaa');
export const EXTERIOREXT360_IMAGE_SETTINGS = build(EXTERIOR360_IMAGE_QUALITY, 'w=2742&h=1690&taa=3&ssaa=2&fxaa');
export const INTERIOR360_IMAGE_SETTINGS = build(INTERIOR360_IMAGE_QUALITY, 'w=1920&h=1080&taa=3&ssaa=2&fxaa');
export const CENTERPANO_IMAGE_SETTINGS = build(CENTERPANO_IMAGE_QUALITY, 'w=4096&h=2304&taa=3&ssaa=2&fxaa', '&360');

//export const FEATURE_SHOT_PREVIEW_IMAGE_SETTINGS = build(FEATURE_SHOT_PREVIEW_IMAGE_QUALITY, 'w=4096&h=2304&taa=3&ssaa=2&fxaa');
export const FEATURE_SHOT_PREVIEW_IMAGE_SETTINGS = build(FEATURE_SHOT_PREVIEW_IMAGE_QUALITY, 'w=4096&h=2731&taa=3&ssaa=2&fxaa');
export const DEALER_SHOT_PREVIEW_IMAGE_SETTINGS = build(FEATURE_SHOT_PREVIEW_IMAGE_QUALITY, 'w=4096&h=3072&taa=3&ssaa=2&fxaa');
export const EXTERIORSTUDIO360_PREVIEW_IMAGE_SETTINGS = build(EXTERIOR360_PREVIEW_IMAGE_QUALITY, 'w=4096&h=2160&taa=3&ssaa=2&fxaa');
export const EXTERIOREXT360_PREVIEW_IMAGE_SETTINGS = build(EXTERIOR360_PREVIEW_IMAGE_QUALITY, 'w=2742&h=1690&taa=3&ssaa=2&fxaa');
export const INTERIOR360_PREVIEW_IMAGE_SETTINGS = build(INTERIOR360_PREVIEW_IMAGE_QUALITY, 'w=4096&h=2304&taa=3&ssaa=2&fxaa');
export const CENTERPANO_PREVIEW_IMAGE_SETTINGS = build(CENTERPANO_PREVIEW_IMAGE_QUALITY, 'w=4096&h=2304&taa=3&ssaa=2&fxaa', '&360');
